export default __webpack_public_path__ + "static/uptimechart-911771d699abe7b21436cf372694c5d7.png";